import React, { Component } from "react";

import Create from "./Create";

export default class FormContainer extends Component {
    render () {
        let {
            actions,

            formType,
            selectedData,

            cardType
        } = this.props;

        switch (formType.toUpperCase()) {
            case "CREATE":
            case "UPDATE":
                return <Create {...{
                    actions,
                    cardType
                }}/>
                break;
            case "DELETE":
                return <p>Are you sure you want to delete {selectedData && selectedData.get("name") ? <span style={{ color: "red" }}>{selectedData.get("name")}</span> : "this data"}?</p>;
                break;
            default:
                return "";
        }
    }

    componentWillUnmount () {
        this.props.actions.setValue({
            selectedData: null,
            formType: "",
            formId: "",
            formTitle: "",

            cardType: ""
        });
    }
}


// WEBPACK FOOTER //
// ./components/EVoucherCardType/FormContainer/index.js